import './index.css';
import { View, Text, Image } from '../../../component';
import { getPlayerName } from '../../../utilities/helper';
import Connection from '../../../utilities/Connection';
import React from 'react';
type Props = {
  item: any;
  completed: boolean;
  lineupsOut: boolean;
  isTeamTeamA: boolean;
  isShowSubstitutionBtn: boolean;
  btnTitle: string;
  onPressSubstitute: any;
  points: number;
};

const SubbedPlayerRow = ({
  item,
  completed,
  isTeamTeamA = false,
  isShowSubstitutionBtn = false,
  btnTitle,
  onPressSubstitute,
  points = 0
}: // lineupsOut
Props) => {
  let {
    shortName = '',
    rating = 0,
    isCaptain = false,
    isViceCaptain = false,
    // points = 0,
    playerId = ''
  } = item;
  let playerName = getPlayerName(shortName);
  return (
    <View
      className={'subbed-player-row-container'}
      onPress={() => onPressSubstitute(item)}
      disabled={!isShowSubstitutionBtn}>
      <>
        {(isCaptain || isViceCaptain) && (
          <View className={'subbed-player-row-captain-container'}>
            <Text className={'subbed-player-row-captain-title'}>{isCaptain ? 'C' : 'VC'}</Text>
          </View>
        )}
        <Image
          style={{
            width: '30px',
            height: '40px'
          }}
          source={`${Connection.getPlayerImageURL(playerId, '')}`}
          placeHolderType={'Player'}
        />
        <View
          className={'subbed-player-row-title-container'}
          style={{
            backgroundColor: isTeamTeamA ? '#c51e23' : '#012f57'
          }}>
          <>
            <Text className={'subbed-player-row-title'}>{playerName}</Text>
            <View className={'subbed-player-row-substitute-container'}>
              <Text className={'subbed-player-row-substitute'}>{`${btnTitle}`}</Text>
            </View>
          </>
        </View>
        {completed ? (
          <Text className={'subbed-player-row-credit-title'}>{`${points} pts`}</Text>
        ) : (
          <Text className={'subbed-player-row-credit-title'}>{`${rating} Cr`}</Text>
        )}
      </>
    </View>
  );
};

export default React.memo(SubbedPlayerRow);
